import React, { useContext, useState } from "react";
import Logo from "../../assets/logo.svg"
import MenuContext from "../../contexts/menu";
import AuthContext from "../../contexts/auth";
import styles from './header.module.css'
import { IoMenu } from "react-icons/io5";
import Options from "../select/options";
import { CustumerContext } from "../../contexts/custumer";
import Select from "../select";
import Text from "../text";


const Content: React.FC = ({ children }) => {
  const { toggleMenu } = useContext(MenuContext);
  const { loggedEmail } = useContext(AuthContext);
  const [showOptions, setShowOptions] = useState<boolean>(false)
  const { current_custumer_description, selectCurrentCustumer, custumer_list, deleteList } = useContext(CustumerContext)

  return (
    <>
      {showOptions && <Options close={() => setShowOptions(false)} selectOption={selectCurrentCustumer} itens={custumer_list} sortAlphabetically />}
      <header className="flex items-center justify-between px-4 bg-white z-40 h-[70px] min-h-0" style={{ gridArea: 'header' }}>
        <div className="w-fit">
          <Select
            noBorder={true}
            noBackgroundColor={true}
            onOpenOptions={() => setShowOptions(true)}
            label={current_custumer_description}
          />
        </div>
        {/* <img src={Logo} alt="" /> */}
        <Text className={`!ml-auto !text-gray-400 !font-bold !px-2.5 ${styles.loggedEmail}`}>{loggedEmail}</Text>
        <button className={`p-1 border-0 bg-transparent cursor-pointer ${styles.menu}`} onClick={toggleMenu}>
          <IoMenu size={28} />
        </button>
      </header>
    </>
  )
}

export default Content;